module.exports = __webpack_public_path__ + "static/media/iphone-12-2-x1.bd93d04f.png";